import { Category } from '../models/category.model';

/** Flatten a category tree (or mixed flat+tree payload) into a unique list by id. */
export function flattenCategories(categories: Category[] | null | undefined): Category[] {
  const byId = new Map<number, Category>();

  const walk = (nodes: Category[] | null | undefined): void => {
    for (const node of nodes ?? []) {
      if (!node || !Number.isFinite(node.id) || node.id <= 0) {
        continue;
      }
      if (!byId.has(node.id)) {
        byId.set(node.id, node);
      }
      if (node.children?.length) {
        walk(node.children);
      }
    }
  };

  walk(categories);
  return Array.from(byId.values());
}

/**
 * Resolve homepage "Shop by Category" cards.
 * Only explicitly configured ids are shown — empty selection means no cards.
 */
export function resolveShopByCategories(
  categories: Category[] | null | undefined,
  shopByCategoryIds: number[] | null | undefined
): Category[] {
  const flat = flattenCategories(categories);
  const selectedIds = (shopByCategoryIds ?? []).filter((id) => Number.isFinite(id) && id > 0);

  if (!selectedIds.length) {
    return [];
  }

  const byId = new Map(flat.map((category) => [category.id, category]));
  return selectedIds
    .map((id) => byId.get(id))
    .filter((category): category is Category => !!category);
}
